export default {
	"title": "Butuh dukungan",
	"image": "Tangkapan layar",
	"email": "Email",
	"name": "Nama",
	"placeholder": "Anda dapat menjelaskan masalah Anda atau berbagi ide Anda dengan kami di sini.",
	"desc": "Umpan balik Anda akan ditangani secepat mungkin.",
	"submit": "Kirim",
}
